import {Dialog, DialogContent, DialogFooter, DialogHeader, DialogTrigger} from "@/components/ui/dialog.tsx";
import Form from "@/components/form/Form.tsx";
import {EmailValidator, RequiredValidator, useForm} from "@/components/form/Helpers.ts";
import TextField from "@/components/editor/fields/TextField.tsx";
import {Button} from "@/components/ui/button.tsx";
import FormActions from "@/components/form/FormActions.tsx";
import {toast} from "sonner";
import {keycloakAdminApi} from "@/main.tsx";

export default function CreateUser() {
    const [form, setForm] = useForm()

    async function submit(): Promise<void> {
        keycloakAdminApi.post(`/users`, {
            email: form.fieldValues.email,
            enabled: true,
            firstName: form.fieldValues.firstName,
            lastName: form.fieldValues.lastName,
            username: form.fieldValues.email.split("@")[0],
            attributes: {
                phone: form.fieldValues.phone,
                title: form.fieldValues.title,
                address: form.fieldValues.address,
                company: form.fieldValues.company,
            }
        }, {withXSRFToken: false}).then((res) => {
            if (res.status == 201) {
                // Success
                window.location.reload() //xd
            }
        }).catch(err => {
            if(err.status == 409) {
                toast.error("A megadott adatokkal már létezik felhasználó")
            } else {
                toast.error("Hiba történt a mentés során")
            }

            console.error(err)

        })
    }

    return <Form formValue={form} onChange={setForm} onSubmit={submit}>
        <Dialog>
            <DialogTrigger asChild><Button>
                Új felhasználó</Button></DialogTrigger>
            <DialogContent>
                <DialogHeader>Új felhasználó</DialogHeader>
                <div className={"flex gap-4 w-full"}>
                    <TextField name={"firstName"} label={"Vezetéknév"} validate={RequiredValidator}/>
                    <TextField name={"lastName"} label={"Keresztnév"} validate={RequiredValidator}/>
                </div>
                <TextField name={"email"} label={"Email cím"} validate={EmailValidator}/>
                <TextField name={"phone"} label={"Telefonszám"}/>
                <TextField name={"title"} label={"Titulus"}/>
                <TextField name={"address"} label={"Cím"}/>
                <TextField name={"company"} label={"Cégnév"}/>
                <DialogFooter>
                    <FormActions>
                        {(actions) => <>
                            <Button onClick={actions.submit} type={"submit"}>Mentés</Button>
                        </>}
                    </FormActions>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    </Form>
}